import { Environment } from 'src/environment';
import configuration, { ConfigStructure } from './configuration';
import { EnvironmentVariables } from './getEnvironmentVariables';

export function getConfiguration(
  envVariables: EnvironmentVariables,
): AppConfig {
  const ghsConfiguration: Partial<AppConfig> = {};

  copyNode(ghsConfiguration, configuration.all, envVariables);

  if (envVariables.environment === Environment.RC) {
    // Uses preprod and overrides with any RC specific configs
    copyNode(
      ghsConfiguration,
      configuration[Environment.PREPROD],
      envVariables,
    );
  }

  copyNode(
    ghsConfiguration,
    configuration[envVariables.environment],
    envVariables,
  );

  return ghsConfiguration as AppConfig;
}

function copyNode(
  dst: Partial<AppConfig>,
  srcNode: ConfigStructure,
  envVariables: EnvironmentVariables,
) {
  if (srcNode) {
    Object.assign(dst, srcNode.common);
    Object.assign(dst, srcNode[envVariables.platform]);

    const brandNode = srcNode[envVariables.brand.toLowerCase()];

    if (brandNode) {
      copyNode(dst, brandNode, envVariables);
    }
  }
}
